export const personalInfo = {
  name: "Laith Alskaf",
  firstName: "Laith",
  lastName: "Alskaf",
  title: "Software Engineer",
  role: "Cross-Platform & Backend Engineer • AI-Augmented Product Builder",
  subtitle: "Building production-grade software products that solve real-world problems through modern engineering, clean architecture, and AI-powered workflows.",

  bio: "I'm a Software Engineer focused on building scalable digital products that combine strong software engineering practices with modern AI-augmented development. Over the past 4+ years, I've designed and delivered cross-platform applications, backend systems, and full-stack software solutions across community platforms, enterprise transportation systems, financial technology, and AI-powered products. I enjoy taking products from concept to production by combining thoughtful architecture, clean code, and user-centered design. My expertise includes cross-platform development, backend engineering, offline-first architecture, API design, and AI integration. I leverage modern AI tools and intelligent development workflows to accelerate delivery, improve code quality, and solve complex engineering challenges without compromising maintainability. I believe great software is built on simplicity, scalability, and long-term thinking. Whether designing a platform serving hundreds of families, developing enterprise operational systems, or building AI-driven business solutions, my goal is always the same: delivering reliable products that create measurable value for users.",
  contact: {
    email: "laithalskaf@gmail.com",
    phone: "+963982055788",
    location: "Sahnaya, Damascus, Syria",
    country: "Syria",
  },

  social: {
    github: "https://github.com/laith-alskaf",
    linkedin: "https://www.linkedin.com/in/laith-alskaf-10a4b4339",
    // twitter: "", // تم التعليق لأنه فارغ
    whatsapp: "https://wa.me/963982055788",
    telegram: "https://t.me/963982055788",
  },

  // 📄 CV والملفات
  cv: {
    // غيّر الرابط إلى رابط CV الخاص بك
    // يمكنك استخدام:
    // - Google Drive: https://drive.google.com/uc?export=download&id=YOUR_FILE_ID
    // - Cloudinary: https://res.cloudinary.com/your-cloud/raw/upload/v123/CV.pdf
    // - أي رابط مباشر لملف PDF
    url: "https://drive.usercontent.google.com/u/0/uc?id=1UHE4aLsXf9ZbTBIIfiFenHWlO7ojX0Uy&export=download", // 👈 غيّر هذا الرابط
    fileName: "Laith_Alskaf_CV.pdf",
    label: "Download CV",
  },

  image: {
    url: "https://res.cloudinary.com/debuadvrz/image/upload/v1784315576/mine_mmpjb4.jpg",
    alt: "Laith Alskaf — Software Engineer",
  },

  languages: [
    { name: "Arabic", level: "Native" },
    { name: "English", level: "Intermediate" },
  ],

  preferences: {
    theme: "dark",
    language: "en",
  },
};
